<section>
  <div class="dropzone" (drop)="onFiledrop($event)">
    <div class="dropzone-content" *ngIf="isDroping">
      <div class="dropzone-icon">
        <div class="dropzone-icon-container">
          <img src="assets/static/icons/upload.svg" alt="">
        </div>
        <div class="dropzone-icon-container">
          <span class="label">Arrastra y suelta tu video aquí</span>
          <span class="filetypes">Tipos de archivos permitidos: MP4, AVI, MOV</span>
        </div>
      </div>
    </div>
  </div>
  <div class="dropzone-visible">
    <input
      type="file"
      accept="allowedTypes"
      multiple="allowMultipleFiles"
      (change)="onFileSelected($event)"
      #fileDropRef
    />
    <label *ngIf="!label; else customLabel" for="fileDropRef">
      Arrastra y suelta tu fichero o
      <b class="bold-blue">navega</b>
    </label>
    <ng-template #customLabel for="fileDropRef">
        {{label}}
    </ng-template>
    <div class="allowed-types">
      Tipos de archivo permitidos:
      {{ allowedList.toUpperCase().replace(".", "") }}
    </div>
    <div *ngIf="incorrectInput" class="error-alert">{{ errorMessage }}</div>
  </div>

  <div *ngIf="files && files.length > 0">
    <table>
      <thead>
        <tr>
          <th class="header-row">Nombre</th>
          <th class="header-row">Tamaño</th>
          <th class="header-row"></th>
          <th class="header-row"></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let file of files; let i = index">
          <td>{{ formatFileNameSize(file.name) }}</td>
          <td>{{ formatBytes(file.size) }}</td>
          <td>
            @if (allowPreview) {
            <button mat-icon-button (click)="viewFile(i)">
              <mat-icon> visibility </mat-icon>
            </button>
            }
          </td>
          <td>
            <button mat-icon-button (click)="deleteFile(i)">
              <img src="assets/static/icons/delete.svg" alt="">
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</section>
